/* eslint-disable array-callback-return */ /* eslint-disable
array-callback-return */
<template>
  <add-edit-dialog>
    <crm-panel title="编辑拜访">
      <div class="page-buttons">
        <crm-button :text="'保存'" @click="handleSave()"> </crm-button>
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="handleCancel()"
        >
        </crm-button>
      </div>
      <el-form
        label-width="160px"
        ref="editForm"
        :model="editForm"
        :rules="editFormRules"
        class="add-edit-form"
      >
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="拜访对象：">
              <el-select
                disabled
                clearable
                v-model="editForm.visitObject"
                @change="handleSelectVisitObject"
              >
                <visit-object-select-types v-once />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5" v-if="editForm.customVisible">
            <el-form-item
              v-if="editForm.customVisible"
              label="客户名称："
              prop="customerId"
              :rules="{ required: true }"
            >
              <el-input v-model="editForm.customerName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5" v-if="editForm.medicalCustomVisible">
            <visit-medical-cusname-select
              v-if="editForm.medicalCustomVisible"
              :val="editForm.medicalCustomerId"
              @change="handleSelectMedicalCustomer"
            >
            </visit-medical-cusname-select>
            <el-form-item
              v-if="!editForm.medicalCustomVisible"
              label="医生名称："
              :rules="{ required: true }"
            >
              <el-input
                v-model="editForm.medicalCustomName"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5" v-if="editForm.buisVisible">
            <el-form-item
              v-if="editForm.buisVisible"
              label="商机名称："
              prop="businessId"
              :rules="{ required: true }"
            >
              <el-input v-model="editForm.businessName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5" v-if="editForm.cluesVisible">
            <el-form-item
              v-if="editForm.cluesVisible"
              label="线索名称："
              prop="cluesId"
              :rules="{ required: true }"
            >
              <el-input v-model="editForm.cluesName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="业务员：" prop="salesmanCode">
              <el-select
                clearable
                filterable
                @change="handleSelectSalesman"
                v-model="editForm.salesmanCode"
                value-key="code"
              >
                <el-option
                  v-for="item in visitCustomerSalesmanDataList"
                  :label="`${item.userName} - ${item.loginId}`"
                  :value="item.code"
                  :key="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5" v-if="editForm.contactVisible">
            <el-form-item label="联系人：" prop="contactId">
              <el-select clearable v-model="editForm.contactId">
                <el-option
                  :key="item.uid"
                  v-for="item in contactsSelect"
                  :label="item.name"
                  :value="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="是否完成：" prop="isFinished">
              <el-select
                clearable
                v-model="editForm.isFinished"
                @change="visitIsFinishedChange"
              >
                <we-yes-or-no-options v-once />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="拜访方式：" prop="visitType">
              <el-select clearable v-model="editForm.visitType">
                <el-option
                  :key="item.uid"
                  v-for="item in visitTypeList"
                  :label="item.name"
                  :value="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="拜访时间：" prop="visitDateStr">
              <el-date-picker
                format="yyyy-MM-dd HH:mm:ss"
                :editable="false"
                value-format="yyyy-MM-dd  HH:mm:ss"
                v-model="editForm.visitDateStr"
                type="datetime"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <!-- :on-preview="handlePictureCardPreview" -->
            <el-form-item label="上传图片：">
              <el-upload
                ref="upload"
                class="upload-demo"
                action="action"
                accept="image/jpg,image/png,image/bmp,image/jpeg,image/gif,image/ico"
                :http-request="handleUpdate"
                :before-upload="beforeAvatarUpload"
                :on-success="handleOnSuccess"
                :on-error="handleOnError"
                :on-preview="handlePictureCardPreview"
                :file-list="uploadList"
                list-type="picture-card"
                :before-remove="beforeRemove"
              >
                <i class="el-icon-plus"></i>
                <!-- <crm-button :text="'上传'"></crm-button> -->
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg、png、bmp、jpeg、gif、ico文件，且不超过5M
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="拜访事宜：" prop="visitAim">
              <el-input
                type="textarea"
                :rows="6"
                placeholder="最多200个字"
                v-model="editForm.visitAim"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="editForm.visitNoteVisible">
          <el-col :span="8" :offset="3">
            <el-form-item label="拜访结果：" prop="visitNote">
              <el-input
                type="textarea"
                :rows="6"
                placeholder="最多500个字"
                v-model="editForm.visitNote"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </crm-panel>
  </add-edit-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AddEditDialog from '@/components/base/addEditDialog';
import CrmPanel from '@/components/base/crmPanel';
import CrmButton from '@/components/base/crmButton';
import VisitCusnameSelect from '@/components/business/visit/visit-cusname-select';
import VisitBusiSelect from '@/components/business/visit/visit-busi-select';
import VisitCluesSelect from '@/components/business/visit/visit-clues-select';
import WeYesOrNoOptions from '~component/base/yes-or-no-options';
import visitObjectSelectTypes from '~component/business/visit/visit-object-select-types';
import { uploadFileVerify } from '@/scripts/reg';

export default {
  components: {
    AddEditDialog,
    CrmPanel,
    CrmButton,
    VisitCusnameSelect,
    VisitBusiSelect,
    VisitCluesSelect,
    WeYesOrNoOptions,
    visitObjectSelectTypes,
  },
  props: {
    visible: { type: Boolean },
    detail: { type: Object },
  },
  data() {
    return {
      // 待提交的表单数据
      editForm: {
        visitObject: '',
        medicalCustomVisible: false,
        // 医生客户
        medicalCustomerId: null,
        medicalCustomName: null,
      },

      // 文件图片
      uploadList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      // 联系人下拉框数据
      contactsSelect: [],
      // 联系人提交
      contactsList: {
        businessId: '',
        customerUid: '',
        salesmanCode: '',
        pageNumber: 1,
        pageSize: 50,
      },
      // 表单校验规则
      editFormRules: {
        customerId: [
          { required: true, message: '请选择客户名称', trigger: 'change' },
        ],
        medicalCustomerId: [
          { required: true, message: '请选择医生客户名称', trigger: 'change' },
        ],
        businessId: [
          { required: true, message: '请选择商机名称', trigger: 'change' },
        ],
        cluesId: [
          { required: true, message: '请选择线索名称', trigger: 'change' },
        ],
        visitObject: [
          { required: true, message: '请选择拜访对象', trigger: 'change' },
        ],
        visitNote: [
          { required: true, message: '请填写拜访结果', trigger: 'change' },
          {
            min: 0,
            max: 500,
            message: '最多500个字',
            trigger: 'blur',
          },
        ],
        visitAim: [
          { required: true, message: '请填写拜访事宜', trigger: 'change' },
          {
            min: 0,
            max: 200,
            message: '最多200个字',
            trigger: 'blur',
          },
        ],
        visitDateStr: [
          { required: true, message: '请填写拜访时间', trigger: 'change' },
        ],
        salesmanCode: [
          { required: true, message: '请选择业务员', trigger: 'change' },
        ],
        contactId: [
          { required: true, message: '请选择联系人', trigger: 'change' },
        ],
        visitType: [
          { required: true, message: '请选择拜访方式', trigger: 'change' },
        ],
        isFinished: [
          { required: true, message: '请选择是否完成', trigger: 'change' },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'authority/userInfo',
      visitTypeList: 'visit/visitTypeList',
      visitCustomerDataList: 'visit/visitCustomerDataList',
      visitCustomerSalesmanDataList: 'visit/visitCustomerSalesmanDataList',
      visitCustomerConvertDataList: 'visit/visitCustomerConvertDataList',
      visitBusinessDataList: 'visit/visitBusinessDataList',
      visitBusinessConvertDataList: 'visit/visitBusinessConvertDataList',
      visitCluesDataList: 'visit/visitCluesDataList',
    }),
  },
  // created() {
  //   console.log('created');
  //   // 业务员下拉
  //   this.handleSelectSalesman();
  // },
  watch: {
    visible(val) {
      this.contactsSelect = [];
      this.uploadList = [];
      if (val) {
        this.editForm = this.detail;
        console.log(this.editForm, 'this.editForm');
        this.getVisitCustomerSalesmanDataList().then(() => {});
        if (this.editForm.fileUrl) {
          this.dialogImageUrl = this.editForm.fileUrl;
          this.uploadList = [
            {
              name: `${this.editForm.fileRecords[0].fileName}`,
              url: `${this.editForm.fileUrl}`,
            },
          ];
        }

        if (this.editForm.customerId && this.editForm.customerType !== 2) {
          this.contactsList.customerUid = this.editForm.customerId;
          this.getVisitCustomerConvertDataList(this.contactsList).then(() => {
            if (this.visitCustomerConvertDataList?.results?.length > 0) {
              this.contactsSelect = this.visitCustomerConvertDataList.results;
              this.editForm.contactId = this.editForm.contactId;
            }
          });
        }
        if (this.editForm.businessId) {
          this.contactsList.businessId = this.editForm.businessId;
          this.getVisitBusinessConvertDataList(this.contactsList).then(() => {
            if (this.visitBusinessConvertDataList.results.length > 0) {
              this.contactsSelect = this.visitBusinessConvertDataList.results;
              this.editForm.contactId = this.editForm.contactId;
            }
          });
        }
      }
    },
  },
  methods: {
    ...mapActions({
      getVisitCustomerDataList: 'visit/getVisitCustomerDataList',
      getVisitCustomerSalesmanDataList:
        'visit/getVisitCustomerSalesmanDataList',
      getVisitCustomerConvertDataList: 'visit/getVisitCustomerConvertDataList',
      getVisitBusinessDataList: 'visit/getVisitBusinessDataList',
      getVisitBusinessConvertDataList: 'visit/getVisitBusinessConvertDataList',
      getVisitCluesDataList: 'visit/getVisitCluesDataList',
      visitUploadFile: 'visit/visitUploadFile',
      deleteVisitUploadFile: 'visit/deleteVisitUploadFile',
      updateHandleVisit: 'visit/updateHandleVisit',
    }),
    handleEmptyeditForm() {
      this.contactsSelect = [];
      this.editForm.contactId = '';
      this.editForm.businessId = '';
      this.editForm.visitObjectId = '';
      this.editForm.customerId = '';
      this.editForm.customName = '';
      this.editForm.cluesId = '';
      this.editForm.medicalCustomerId = '';
      this.editForm.medicalCustomName = '';
    },
    // 拜访类型选择
    handleSelectVisitObject(val) {
      this.handleEmptyeditForm();
      if (val) {
        this.editForm.visitObject = val;
      }
      if (this.editForm.visitObject === 1) {
        // 客户
        this.editForm.customVisible = true;
        this.editForm.contactVisible = true;

        // 商机下拉展示
        this.editForm.buisVisible = false;
        // 线索下拉展示
        this.editForm.cluesVisible = false;
      } else if (this.editForm.visitObject === 2) {
        // 客户

        this.editForm.customVisible = false;
        this.editForm.contactVisible = true;
        // 商机下拉展示
        this.editForm.buisVisible = true;
        // 线索下拉展示
        this.editForm.cluesVisible = false;
      } else if (this.editForm.visitObject === 3) {
        // 客户
        this.editForm.customVisible = false;
        this.editForm.contactVisible = false;
        // 商机下拉展示
        this.editForm.buisVisible = false;
        // 线索下拉展示
        this.editForm.cluesVisible = true;
      } else if (this.editForm.visitObject === 4) {
        // 医生客户
        this.editForm.customVisible = false;
        this.editForm.medicalCustomVisible = true;
        this.editForm.contactVisible = true;

        // 商机下拉展示
        this.editForm.buisVisible = false;
        // 线索下拉展示
        this.editForm.cluesVisible = false;
      }
    },
    // 客户选择
    handleSelectCustomer(value) {
      const customerData = this.visitCustomerDataList.results;
      // eslint-disable-next-line arrow-parens
      let cus = null;
      Object.keys(customerData).map((key) => {
        if (customerData[key].uid === value) {
          // eslint-disable-next-line no-const-assign
          cus = customerData[key];
        }
        // eslint-disable-next-line consistent-return
        return null;
      });

      if (cus !== null && cus.uid === value && cus.customerType === 2) {
        this.editForm.contactVisible = false;
      } else {
        this.editForm.contactVisible = true;
      }

      this.contactsSelect = [];
      this.editForm.customerId = value;
      this.contactsList.customerUid = value;
      this.contactsList.businessId = '';
      this.editForm.visitObjectId = value;
      this.editForm.contactId = '';
      if (value && this.editForm.contactVisible) {
        this.handleSelectConvert(value);
      } else {
        this.contactsSelect = [];
      }
    },
    // 商机选择
    handleSelectBusiness(value) {
      this.contactsSelect = [];
      this.editForm.businessId = value;
      this.editForm.visitObjectId = value;
      this.contactsList.businessId = value;
      this.contactsList.customerUid = '';
      this.editForm.contactId = '';
      if (value) {
        this.handleSelectConvert(value);
      } else {
        this.contactsSelect = [];
      }
    },
    // 医生客户选择
    handleSelectMedicalCustomer(value) {
      const customerData = this.visitMedicalCustomerDataList.results;
      // eslint-disable-next-line arrow-parens
      let cus = null;
      Object.keys(customerData).map((key) => {
        if (customerData[key].uid === value) {
          // eslint-disable-next-line no-const-assign
          cus = customerData[key];
        }
        // eslint-disable-next-line consistent-return
        return null;
      });

      if (cus !== null && cus.uid === value && cus.customerType === 2) {
        this.editForm.contactVisible = false;
      } else {
        this.editForm.contactVisible = true;
      }

      this.contactsSelect = [];
      this.editForm.medicalCustomerId = value;
      this.contactsList.customerUid = value;
      this.contactsList.businessId = '';
      this.editForm.visitObjectId = value;
      this.editForm.contactId = '';
      if (value && this.editForm.contactVisible) {
        this.handleSelectConvert(value);
      } else {
        this.contactsSelect = [];
      }
    },
    // 线索选择
    handleSelectClues(value) {
      this.contactsSelect = [];
      this.editForm.contactId = '';
      this.editForm.visitObjectId = value;
      this.editForm.cluesId = value;
    },
    // 联系人选择
    handleSelectConvert(val) {
      this.editForm.contactId = '';
      if (val) {
        // 客户联系人
        if (this.contactsList.customerUid) {
          this.getVisitCustomerConvertDataList(this.contactsList).then(() => {
            if (this.visitCustomerConvertDataList.results.length > 0) {
              this.contactsSelect = this.visitCustomerConvertDataList.results;
              this.editForm.contactId = this.contactsSelect[0].uid;
            }
          });
        }
        // 商机联系人
        if (this.contactsList.businessId) {
          this.getVisitBusinessConvertDataList(this.contactsList).then(() => {
            if (this.visitBusinessConvertDataList.results.length > 0) {
              this.contactsSelect = this.visitBusinessConvertDataList.results;
              this.editForm.contactId = this.contactsSelect[0].uid;
            }
          });
        }
      } else {
        this.contactsList = [];
      }
    },
    // 获取业务员
    handleSelectSalesman(val) {
      if (val) {
        this.editForm.salesmanCode = val;
      }
    },
    // 取消
    handleCancel() {
      this.$emit('close');
      this.$refs.editForm.resetFields();
    },
    // 新增保存
    handleSave() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          // this.editForm.addConverts = [];
          // this.editForm.addConverts = this.editForm.converts;
          const {
            customerId,
            businessId,
            cluesId,
            visitObject,
            ...otherUpdateParams
          } = this.editForm;
          /* eslint-disable */
          const visitObjectId =
            visitObject === 2
              ? businessId
              : visitObject === 3
              ? cluesId
              : customerId;
          this.updateHandleVisit({
            ...this.editForm,
            visitObjectId,
          }).then(() => {
            this.$message({
              type: 'success',
              message: '编辑成功！',
            });
            this.$refs.editForm.resetFields();
            this.$emit('close');
            this.$emit('success');
          });
        }
      });
    },

    // 拜访是否完成
    visitIsFinishedChange() {
      if (this.editForm.isFinished === 1) {
        this.editForm.visitNoteVisible = true;
      } else if (this.editForm.isFinished === 0) {
        this.editForm.visitNoteVisible = false;
      } else {
        this.editForm.visitNoteVisible = false;
      }
    },
    // 文件上传
    handleOnError() {},
    // 图片展示
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 文件上传成功时同步文件列表
    handleOnSuccess(response, file, fileList) {
      // 覆盖上一个文件
      if (fileList !== null && fileList.length > 0) {
        this.uploadList = [fileList[fileList.length - 1]];
      } else {
        this.uploadList = fileList;
      }
    },
    // 文件上传前文件大小拦截
    async beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 5MB!');
        return Promise.reject();
      }
      /* eslint-disable */
      try {
        return await uploadFileVerify(file.name);
      } catch (e) {
        this.$message(e);
        return Promise.reject();
      }
    },
    // 展示的文件列表中删除文件，将传给后端的文件id删除
    beforeRemove(file, fileList) {
      const delIndex = this.uploadList.findIndex(item => item.url === file.url);
      if (delIndex !== -1) {
        this.deleteVisitUploadFile({
          id: this.editForm.fileId,
        })
          .then(() => {
            this.editForm.fileId = '';
          })
          .catch(error => {
            this.$refs.upload.uploadFiles = JSON.parse(
              JSON.stringify(this.uploadList),
            );
            this.$forceUpdate();
          });
      }
      return true;
    },
    // 文件上传
    handleUpdate(item) {
      this.notify = this.$notify({
        iconClass: 'el-icon-loading',
        title: '',
        message: '正在上传中，请稍后...',
        duration: 0,
        showClose: false,
      });
      const params = new FormData();
      params.append('file', item.file);
      params.append('fileName', item.file.name);
      this.visitUploadFile({
        params,
        config: { 'Content-Type': 'multipart/form-data', timeout: 100000 },
      })
        .then(res => {
          this.$message({
            type: 'success',
            message: '上传成功！',
          });
          item.onSuccess();
          this.editForm.fileId = res.data.data;
        })
        .catch(() => {
          item.onError();
        })
        .finally(() => {
          if (this.notify) this.notify.close();
        });
    },
  },
};
</script>

<style lang="less">
@import '~@/styles/var.less';
.el-select {
  width: 200px;
}
.el-textarea .upload-demo {
  width: 400px;
}
.el-input__inner {
  width: 200px;
}
</style>
